import Reveal from '@/pages/zz-review/components/Reveal';

export default function PublicBenefitSection() {
  return (
    <section id="benefit" className="w-full py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-10">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              公益受惠
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              這不只是一場出版募資
            </h2>
          </div>
        </Reveal>

        <Reveal delay={60}>
          <div className="rounded-lg border border-primary-200/70 bg-background-50 px-6 md:px-10 py-8 md:py-10">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              本次募資首先完成《1001旋轉門》的紙本出版與實踐入口；隨著書籍、RG Portal 與生命實踐方法逐步公開，集資成果將使不特定多數人受惠，讓更多人有機會從自己的生活、工作與關係開始，學習回到中軸，把生命成長落實為可以持續實踐的方法。
            </p>

            <div className="border-t border-background-200/70 mt-6 pt-6 text-center">
              <p
                className="text-base md:text-lg text-foreground-900 font-medium"
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                集資金額將使「不特定多數人」受惠。
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}